import LicensesLayout from "../layouts/LicensesLayout";

const Licenses = () => {
  return (
    <div className="p-8 bg-gray-100">
      <LicensesLayout />
    </div>
  );
};

export default Licenses;
